import { produce } from 'immer';

import { RevertCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/revertCampaignPlaceEditor';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function revertCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: RevertCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId, place } = action;

        draft[editorId].isOpen = false;
        draft[editorId].pageId = place.pageId;
        draft[editorId].placeId = place.placeId;
    });
}
